
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/modal";
import { useState } from "react";
import { useI18n } from "@/hooks/useI18n";

export const CreateQuoteModal = ({ isOpen, onClose, onSend }: { isOpen: boolean; onClose: () => void; onSend: () => Promise<void>; }) => {
  const { t } = useI18n();
  const [loading, setLoading] = useState(false);
  const handleSend = async () => {
    setLoading(true);
    await onSend();
    setLoading(false);
    onClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('itinerary.submitQuoteRequest')}
      size="sm"
      showHeader={true}
      footer={
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} disabled={loading}>{t('common.close')}</Button>
          <Button onClick={handleSend} disabled={loading} className="bg-black text-white hover:bg-gray-800">
            {loading ? t('common.sending') : t('itinerary.submitRequest')}
          </Button>
        </div>
      }
    >
      <div className="p-4 my-4 text-gray-700">
        {t('itinerary.quoteRequestDescription')}
      </div>
    </Modal>
  );
};